import {Page, mergeSx} from '@hconnect/uikit/src/lib2'
import {usePlantStartOfToday} from '@hconnect/upm'
import React, {useMemo} from 'react'
import {useTranslation} from 'react-i18next'

import {
  MaterialDemandCard,
  SalesForecastActions,
  getSalesForecastDefaultTimeFrame
} from '../components'
import {FEATURE_NAMESPACE} from '../consts'
import {
  MaterialDemandEditProvider,
  MaterialDemandFiltersProvider,
  SelectedTimeframeProvider
} from '../providers'
import {type MomentRange} from '../utils'

export const PageSalesForecast: React.FC = () => {
  const {t} = useTranslation(FEATURE_NAMESPACE)

  const startOfToday = usePlantStartOfToday()

  const defaultTimeframe: MomentRange = useMemo(
    () => getSalesForecastDefaultTimeFrame(startOfToday),
    [startOfToday]
  )

  return (
    <SelectedTimeframeProvider defaultTimeframe={defaultTimeframe}>
      <MaterialDemandFiltersProvider>
        <MaterialDemandEditProvider>
          {/* <TourBanner sx={{mt: 3, mx: {xs: 2, lg: 6}}} /> */}
          <Page
            title={t('navItems.salesForecast')}
            headerActionContent={<SalesForecastActions />}
            data-test-id="page_salesForecast"
            sx={{px: {xs: 2, lg: 6}}}
            nameHeaderSx={mergeSx({mb: 1.5, px: 3})}
            boxed={false}
          >
            <MaterialDemandCard />
          </Page>
        </MaterialDemandEditProvider>
      </MaterialDemandFiltersProvider>
    </SelectedTimeframeProvider>
  )
}
